import React from 'react';
import MathCCAClass12025 from 'views/MathCCAClass12025';

const MathClubPage = () => {
  return <MathCCAClass12025/>;
};

export default MathClubPage;

